import instance from '../../api'
import apiExportResponseHandler from '../../api-utils/apiExportResponseHandler'
import { transformSearchParams } from '../../utils'

const BASE_ENDPOINT = '/api/admin/stores'

export const createStore = (fields) => instance.post(BASE_ENDPOINT, fields)

export const getReverseDCList = () => instance.get('/api/admin/reverse_dcs')

export const getPaymentMethods = (store_id) => instance.get(`/api/admin/payment_methods?store_id=${store_id}`)

export const deletePaymentMethod = (id) => instance.delete(`/api/admin/payment_methods/${id}`)

export const updatePaymentMethod = (id, fields) => instance.put(`/api/admin/payment_methods/${id}`, fields)

export const getStoreList = (search) => instance.get(`${BASE_ENDPOINT}${search ? `?${search}` : ''}`)

export const getBankData = (id) => instance.get(`${BASE_ENDPOINT}/${id}/bank_data`)

export const updateStore = (fields) => instance.put(`${BASE_ENDPOINT}/${fields.id}`, fields)

export const getBalanceForRange = (id, dateRange) =>
  instance.get(
    `${BASE_ENDPOINT}/${id}/balance_between?begin_date=${dateRange.begin_date}&end_date=${dateRange.end_date}`,
  )

export const adjustBalanceBetween = (id, range) =>
  instance.post(`${BASE_ENDPOINT}/${id}/adjust_balance_between`, range)

export const getStoresBatchBalance = (search) =>
  instance.get(`${BASE_ENDPOINT}/batch_balance_between${search ? `?${search}` : ''}`)

export const createStoreLink = (fields) => instance.post(`${BASE_ENDPOINT}/create_with_share_link`, fields)

export const updateStoreLink = (id) => instance.put(`${BASE_ENDPOINT}/new_link/${id}`)

export const deleteStore = (id) => instance.delete(`${BASE_ENDPOINT}/${id}`)

export const switchVirtualStore = (id) => instance.put(`${BASE_ENDPOINT}/${id}/switch_to_virtual`)

export const createCorporateUser = (fields) => instance.post(`${BASE_ENDPOINT}/${fields.store_id}/users`, fields)

export const exportStores = (filter) =>
  fetch(`${BASE_ENDPOINT}/export${filter ? `?${filter}` : ''}`, {
    headers: {
      'content-type': 'text/csv;charset=UTF-8',
    },
  }).then(apiExportResponseHandler)

const ORDER_REQUESTS_ENDPOINT = '/api/admin/order_requests'

export const getStoreOrders = (params) =>
  instance.get(`${ORDER_REQUESTS_ENDPOINT}?${transformSearchParams(params, ['created_at', 'updated_at'])}`)

export const createOrderRequest = (fields) =>
  instance.post(ORDER_REQUESTS_ENDPOINT, fields)

export const cancelOrderRequest = (id) =>
  instance.put(`${ORDER_REQUESTS_ENDPOINT}/${id}/cancel`)

export const deleteOrderRequest = (id) =>
  instance.delete(`${ORDER_REQUESTS_ENDPOINT}/${id}`)
